export default __webpack_public_path__ + "static/slovenia-control-43569cc0300e9ae35c2693e1737dc795.png";